import capterra from '/public/images/signup/capterra.webp';
import softwareadvice from '/public/images/signup/softwareadvice.webp';
import GetApp from '/public/images/signup/GetApp.webp';
import leader from '/public/images/signup/leader.webp';
import best_roi from '/public/images/signup/best_roi.webp';
import best_support from '/public/images/signup/best_support.webp';
import easiest_to_use from '/public/images/signup/easiest_to_use.webp';
import high_performer from '/public/images/signup/high_performer.webp';

export const reassuranceLogos = [
    {
        image: capterra,
        alt: 'Capterra'
    },
    {
        image: softwareadvice,
        alt: 'Software Advice'
    },
    {
        image: GetApp,
        alt: 'GetApp'
    }
];

export const reassuranceLogosAwards = [
    {
        image: leader,
        alt: 'Social Media Analytics Leader EMEA'
    },
    {
        image: best_roi,
        alt: 'Social Media Listening Tools Best Estimated ROI'
    },
    {
        image: best_support,
        alt: 'Social Media Listening Tools Best Support'
    },
    {
        image: easiest_to_use,
        alt: 'Social Media Listening Tools Easiest To Use'
    },
    {
        image: high_performer,
        alt: 'Social Media Suites High Performer'
    }
];
